import React, { useEffect, useState } from 'react';
import './Automations.scss';
import style from './Automations.scss.json';
import { Tabs } from '../components/Tabs';
import { automation1, automation2, automation3, automation5 } from '../data/automations';
import { LimitAdSpend } from '../components/Automation/LimitAdSpend';
import ResetBidAmounts from '../components/Automation/ResetBidAmount';
import { RunConvertingAds } from '../components/Automation/RunConvertingAds';
import { RunProfitableAds } from '../components/Automation/RunProfitableAds';

export default function Automations() {
    return (
        <div className={style.container}>
            <Tabs.Root defaultValue={automation3.identifier as string}>
                <Tabs.List>
                    <Tabs.Trigger value={automation3.identifier as string} className={style.tabTrigger}>{automation3.name}</Tabs.Trigger>
                    <Tabs.Trigger value={automation2.identifier as string} className={style.tabTrigger}>{automation2.name}</Tabs.Trigger>
                    <Tabs.Trigger value={'Reset Bid Amounts'} className={style.tabTrigger}>Reset Bid Amounts</Tabs.Trigger>
                    <Tabs.Trigger value={automation5.identifier as string} className={style.tabTrigger}>{automation5.name}</Tabs.Trigger>
                </Tabs.List>
                <Tabs.Content value={automation3.identifier as string}>
                    <RunConvertingAds/>
                </Tabs.Content>
                <Tabs.Content value={automation2.identifier as string}>
                    <LimitAdSpend />
                </Tabs.Content>
                <Tabs.Content value={'Reset Bid Amounts'}>
                    <ResetBidAmounts/>
                </Tabs.Content>
                <Tabs.Content value={automation5.identifier as string}>
                    <RunProfitableAds/>
                </Tabs.Content>
            </Tabs.Root>
        </div>
    );
}